import React, { useState } from "react";
import Auth from "./Auth";
import { useAuth } from "./../util/auth.js";

function ChangePass(props) {
  const auth = useAuth();
  const [status, setStatus] = useState({ type: "none" });

  const onSubmit = ({ pass }) => {
    setStatus({ type: "pending" });
    auth
      .confirmPasswordReset(pass)
      .then(() => {
        setStatus({
          type: "success",
          message: "Your password has been changed. You can now close this window"
        });
      })
      .catch(error => {
        setStatus({
          type: "error",
          message: error.message
        });
      });
  };

  return (
    <Auth
      mode="changepass"
      onSubmit={onSubmit}
      status={status}
      {...props}
    ></Auth>
  );
}

export default ChangePass;
